import React, { Component } from "react";

class TaskLoading extends Component {
	render() {
		return (
			<React.Fragment>
				<div className="_17YZn" style={{background: 'rgb(240, 240, 245)'}}>
                    <div className="_1AAnO">
                        <div className="VJHbK">
                        <div className="_20fAu _2ur2j" style={{marginBottom: '12px', borderRadius: '20px'}}>
                            <span className="_3BQ0v" style={{background: 'rgb(240, 240, 245)'}} />
                            <div className="_3-jFS _1tJ9r">
                            <div className="_2veGz" />
                            </div>
                        </div>
                        <div className="_1ZFhi" />
                        </div>
                        <div className="_20fAu _2ur2j" style={{marginBottom: '12px', borderRadius: '20px'}}>
                        <span className="_3BQ0v" style={{background: 'rgb(240, 240, 245)'}} />
                        <div className="_3-jFS _1tJ9r">
                            <div className="_2veGz" />
                        </div>
                        </div>
                        <div className="_20fAu Ei8Sl">
                        <div className="_1gTAE">
                            <div className="PmuSM" />
                        </div>
                        <div className="_1lkU8">
                            <div className="mBwpX" />
                            <div className="_3zzpD">
                            <div className="gLls9" />
                            </div>
                        </div>
                        <div className="_1lkU8">
                            <div className="mBwpX" />
                            <div className="_3zzpD">
                            <div className="gLls9" />
                            </div>
                        </div>
                        <div className="_1lkU8">
                            <div className="mBwpX" />
                            <div className="_3zzpD">
                            <div className="gLls9" />
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
			</React.Fragment>
		);
	}
}

export default TaskLoading;
